/**
 * Copyright 2025 SweetCode. All rights reserved.
 *
 * Reddit browser pixel functions (free tier)
 *
 * Everything the Reddit Pixel needs to load and fire browser events, plus the
 * order line formatting the adapter attaches to the purchase. The Conversions
 * API base payload (visitor UUID, click ID, user data) lives in
 * functions_premium.js.
 * */

(function (pmw, undefined) {

	pmw.getRedditAdvertiserId = () => {
		return pmwDataLayer.pixels.reddit.advertiser_id;
	};

	// https://redditinc.force.com/helpcenter/s/article/Reddit-Pixel-Advanced-Matching
	//
	// Advanced Matching is a Pro setting and the hashed user data is only in
	// the data layer on Pro, so the plain init runs on free.
	pmw.redditInitEvent = () => {
		try {
			if (
				(
					pmwDataLayer.general.user_logged_in
					|| "order_received_page" === pmwDataLayer?.shop?.page_type
				)
				&& pmwDataLayer?.pixels?.reddit?.advanced_matching
			) {
				let data = {
					optOut                  : false,
					useDecimalCurrencyValues: true,
				};

				if (pmwDataLayer?.user?.email?.sha256) {
					data.email = pmwDataLayer.user.email.sha256;
				}

				if (pmwDataLayer?.user?.id?.sha256) {
					data.externalId = pmwDataLayer.user.id.sha256;
				}

				rdt("init", pmw.getRedditAdvertiserId(), data);

			} else {
				rdt("init", pmw.getRedditAdvertiserId());
			}
		} catch (e) {
			console.error(e);
		}
	};

	pmw.loadRedditPixel = function () {

		try {
			// @formatter:off
			!function(w,d){if(!w.rdt){var p=w.rdt=function(){p.sendEvent?p.sendEvent.apply(p,arguments):p.callQueue.push(arguments)};p.callQueue=[];var t=d.createElement("script");t.src="https://www.redditstatic.com/ads/pixel.js",t.async=!0;var s=d.getElementsByTagName("script")[0];s.parentNode.insertBefore(t,s)}}(window,document);

			pmw.redditInitEvent();

			// Track PageVisit - the actual event with conversion ID will be fired
			// via the unified event processor (pmw:pixel:page-view) to ensure
			// the same conversion ID is used for both browser and S2S
			// @formatter:on

			pmwDataLayer.pixels.reddit.loaded = true;

		} catch (e) {
			console.error(e);
		}
	}

	/**
	 * Can fire Reddit event
	 * @return {boolean}
	 */
	pmw.canFireRedditEvent = () => {
		if (!pmwDataLayer?.pixels?.reddit?.loaded) return false;

		if (!pmw.consent.categories.get().marketing) return false;

		return true;
	};

	/**
	 * Can not fire Reddit event
	 *
	 * @return {boolean}
	 */
	pmw.canNotFireRedditEvent = () => {
		return !pmw.canFireRedditEvent();
	};

	pmw.redditGetProductsFromCart = () => {

		let orderItems = [];

		Object.values(pmwDataLayer.order.items).forEach((item) => {

			const itemId  = pmwDataLayer?.shop?.variations_output && 0 !== item.variation_id ? item.variation_id : item.id;
			const product = pmw.getDataLayerProduct(itemId);

			// A product deleted since the order was placed has no data left to
			// report. Skip the line rather than lose the whole conversion.
			if (!product) {
				pmw.console.warn("Reddit: skipped an order item without product data: " + itemId);
				return;
			}

			orderItems.push({
				id      : pmw.getProductIdForSpecificPixel(product, "reddit"),
				category: ( product.category || [] ).join("/"),
				name    : product.name,
			});
		});

		return orderItems;

	};

}(window.pmw = window.pmw || {}));
